export const CUT_TAG = ['SOC', 'BR'];

export const CUT_TAG_VALUES: {
  [key: string]: string;
} = {
  'SOC': 'Open World Survival Craft',
  'BR': 'Battle Royale',
  'Tarkov-Like': 'Tarkov-Like',
};

export const CUT_TAG_VALUES_CN: {
  [key: string]: string;
} = {
  'SOC': '开放世界生存建造',
  'BR': '大逃杀',
  'Tarkov-Like': '类逃离塔可夫',
};
